/**
 * * Получить кадр видео
 * @param file Файл для получения кадра
 * @param timeInSeconds Время в секундах для получения кадра
 * @returns
 */
export const getVideoFrame = (
  file: File,
  timeInSeconds: number
): Promise<string | undefined> => {
  return new Promise((resolve) => {
    const video = document.createElement("video");
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    if (!ctx) {
      return resolve(undefined); // Ошибка при создании canvas context
    }

    const url = URL.createObjectURL(file);
    video.src = url;

    video.onloadedmetadata = () => {
      const frameTime =
        timeInSeconds > video.duration
          ? video.duration >= 1
            ? 1
            : 0
          : timeInSeconds;
      video.currentTime = frameTime;

      video.onseeked = async () => {
        const videoWidth = video.videoWidth;
        const videoHeight = video.videoHeight;

        const maxWidth = 720;
        const maxHeight = 480;
        let outputWidth = videoWidth;
        let outputHeight = videoHeight;

        if (videoWidth > maxWidth || videoHeight > maxHeight) {
          const widthRatio = maxWidth / videoWidth;
          const heightRatio = maxHeight / videoHeight;
          const minRatio = Math.min(widthRatio, heightRatio);

          outputWidth = Math.floor(videoWidth * minRatio);
          outputHeight = Math.floor(videoHeight * minRatio);
        }

        canvas.width = outputWidth;
        canvas.height = outputHeight;
        setTimeout(() => {
          try {
            ctx.drawImage(video, 0, 0, outputWidth, outputHeight);

            const dataUrl = canvas.toDataURL("image/png");
            URL.revokeObjectURL(url);
            resolve(dataUrl); // Возвращаем base64 изображение
          } catch (err) {
            console.error("Error drawing the video frame:", err);
            URL.revokeObjectURL(url);
            resolve(undefined); // Возвращаем undefined, если возникла ошибка отрисовки
          }
        }, 100); // Задержка в 100 мс перед отрисовкой
      };

      video.onerror = () => {
        URL.revokeObjectURL(url);
        resolve(undefined); // Ошибка загрузки видео
      };
    };

    video.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(undefined); // Ошибка загрузки метаданных видео
    };
  });
};
